import React, { useState, useCallback } from 'react';
import { checkIsIntegerNumber, checkIsFloatNumber } from 'shared/utils';

export type TextFieldState = string;
export type HandleChangeTextFieldState = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => void;
export type SetTextFieldState = React.Dispatch<React.SetStateAction<string>>;
export type ResetTextFieldState = () => void;
type OnChangeCallback = (event: React.ChangeEvent<HTMLInputElement>) => void;
type TextFieldStateType = 'text' | 'int' | 'float';
type ValidateValue = (value: string) => boolean;
export interface TextFieldSettings {
  fieldType?: TextFieldStateType;
  validateValue?: ValidateValue;
}

const checkIsFieldTypeText = (fieldType: TextFieldStateType) => (fieldType === 'text');
const checkIsFieldTypeNumber = (fieldType: TextFieldStateType) => (fieldType === 'int');
const checkIsFieldTypeFloat = (fieldType: TextFieldStateType) => (fieldType === 'float');

export const useTextFieldState = (
  initValue = '',
  onChangeCallback?: OnChangeCallback | null,
  settings?: TextFieldSettings
) => {
  const { fieldType = 'text', validateValue } = settings || {};
  const [value, setValue] = useState<TextFieldState>(() => initValue);

  const handleChangeValue = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { target: { value } } = event;
    if (
      checkIsFieldTypeText(fieldType)
      || (checkIsFieldTypeNumber(fieldType) && (value === '' || checkIsIntegerNumber(value)))
      || (checkIsFieldTypeFloat(fieldType) && (value === '' || (validateValue ? validateValue(value) : checkIsFloatNumber(value))))
    ) setValue(value);
    if (onChangeCallback) onChangeCallback(event);
  }, [setValue, onChangeCallback, validateValue, fieldType]);

  const resetValue = useCallback(() => {
    setValue(initValue);
  }, [setValue, initValue]);

  return [value, handleChangeValue, setValue, resetValue] as const;
};
